import ProfilePicture from "@/components/common/profile-picture";
import VerifiedBadgeCheck from "@/components/common/verified-badge-check";
import { cn, formatImageUrl, getCountryIso } from "@/lib/utils";
import "flag-icons/css/flag-icons.min.css";
import Link from "next/link";

type LeaderBoardListingCardProps = {
	name: string;
	howDoYouIdentifyYourself: string;
	company: string;
	location: string;
	image: string;
	isVerified: boolean;
	isAmbassador: boolean;
	isFounder: boolean;
	username: string;
};

const LeaderBoardListingCard = ({
	name,
	howDoYouIdentifyYourself,
	company,
	image,
	location,
	isVerified,
	isAmbassador,
	isFounder,
	username,
}: LeaderBoardListingCardProps) => {
	const countryIso = getCountryIso(location)?.toLowerCase();

	return (
		<Link href={`/${username}`}>
			<div className="flex flex-col items-center justify-center gap-1">
				<ProfilePicture
					profilePictureUrl={formatImageUrl(image)}
					isVerified={isVerified}
					isFounder={isFounder}
					isAmbassador={isAmbassador}
					className={{
						container: "h-16 w-16 rounded-full p-1",
						image: "h-14 w-14 rounded-full",
						badgeImage: "-bottom-8 h-16 w-16",
					}}
				/>

				<div className="mt-4 flex items-center gap-1 text-center">
					<h6 className="relative w-min break-words text-sm font-semibold">
						<span>{name}</span>

						{isFounder && isVerified && (
							<div className="absolute -right-6 top-1/2 -translate-y-1/2">
								<VerifiedBadgeCheck iconClassName="w-5 h-5" />
							</div>
						)}
					</h6>
				</div>

				<div className="my-1 flex items-center gap-2">
					<span className="w-min break-words text-center text-xs font-medium text-gray-400">
						{howDoYouIdentifyYourself}
					</span>

					<span
						className={cn(
							"h-full rounded-sm",
							countryIso && location ? `fi fi-${countryIso}` : "hidden"
						)}
					></span>
				</div>

				<span className="text-center text-xs font-medium text-gray-800">{company}</span>
			</div>
		</Link>
	);
};

export default LeaderBoardListingCard;
